import { min, max } from 'd3-array';
import { stack, stackOffsetDiverging } from 'd3-shape';
import { linearAxis, bandAxis } from '../../../factory/axes';
import { ordinalScale } from '../../../factory/scales';

import data from './data/data.json';
import { teal, detention } from './utils/colors';

export default function (props) {
  const { initialWidth, initialHeight } = props;
  const keys = Object.keys(data[0]).slice(1);

  const series = stack()
    .offset(stackOffsetDiverging)
    .keys(keys)(data);

  const margins = {
    top: 5,
    right: 50,
    bottom: 50,
    left: 50,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  const maxValue = max(series, serie => max(serie, d => d[1]));
  const minValue = min(series, serie => min(serie, d => d[0]));
  const padding = 0.15;

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, width],
    domain: data.map(d => d.label),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [height, 0],
    domain: [Math.min(0, minValue), 40],
    nice: false,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  const colorScale = ordinalScale({
    range: detention[keys.length - 1],
    domain: keys,
  });

  return {
    colorScale,
    data: series,
    height,
    initialWidth,
    initialHeight,
    margins,
    width,
    x,
    y,
    xAxis,
    yAxis,
  };
}
